export const Socios = () => {
  return (
    <section
      className="light-section"
      style={{ marginBlock: "8rem", position: "relative" }}
    >
      {/* <img
        alt="dotted-line"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/about/linea-socios-10.png`}
        className="linea-socios"
      /> */}
      <div className="columna">
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Siempre innovando</p>
        </span>

        <p className="section-title">
          <span>
            De una necesidad
            <br />
            a una visión:
            <br />
            <span style={{ color: "var(--red-highlight)" }}>
              {" "}
              así nació binamics
            </span>
          </span>
        </p>

        <span className="section-subtitle" />
      </div>

      <div className="columna">
        <div className="horizontal" style={{ justifyContent: "space-evenly" }}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/imagenes/about/pablo-14.png`}
            alt="pablo"
            style={{ width: "35%", marginTop: "2rem" }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/assets/imagenes/about/raul-15.png`}
            alt="pablo"
            style={{ width: "35%" }}
          />
        </div>

        <span
          className="section-subtitle"
          style={{ width: "80%", marginInline: "auto" }}
        >
          <p>
            Todo empezó en 2010, con una idea simple: ayudar a las cooperativas
            agropecuarias a tomar mejores decisiones con tecnología. Vimos que
            faltaban datos claros, herramientas útiles, y alguien que entendiera
            realmente cómo funciona el agro desde adentro. Arrancamos con
            soluciones de inteligencia de negocios para el campo, y en 2012
            dimos un paso clave: nos convertimos en partner oficial de
            Strategy. Desde entonces, la innovación no paró.
          </p>
          <br />
          <p>
            Hoy, después de muchos kilómetros recorridos, nuestros productos
            evolucionaron.{" "}
            <b>
              Ya no solo acompañamos al agro: también trabajamos con
              industrias que quieren transformar sus datos en decisiones y
              crecer con inteligencia.{" "}
            </b>
          </p>
          <br />
          <span>
            ¿Nuestro foco?{" "}
            <b>
              Siempre el mismo: entender tus desafíos y crear tecnología que te
              sirva de verdad.
            </b>
          </span>
        </span>
      </div>
    </section>
  );
};
